<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <searchBar :searchData="searchData" @search="search">
                    </searchBar>
                </div>
                <div style="display: flex;padding: 15px 10px 10px 10px">
                    <btnBar :btns="btnList" @doBtn="doBtn">
                    </btnBar>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import searchBar from './searchBar/build'
    import btnBar from './btnBar'

    export default {
        name: 'toolBar',
        props: ['menuId', 'searchData', 'toolHeight', 'loading'],
        components: {
            searchBar,
            btnBar,
        },
        data() {
            return {
                btnList: [],
                searBarHeight: 35,
                loginInfo: this.$store.state.loginInfo,
            }
        },
        async mounted() {
            if (this.menuId)
                await this.getBtnList();
            if (this.searchData && this.searchData.fields) {
                this.searchData.fields.map(item => {
                    if (item.endRow) {
                        this.searBarHeight += 35
                    }
                })
            }
        },
        methods: {
            async getBtnList() {
                let roleIds = this.loginInfo.user.roleIds
                this.$emit('update:loading', true);
                let param = {
                    url: "/systembutton/findByMenuId",
                    param: {
                        menuId: this.menuId,
                        roleId:roleIds
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)

                if (data.infoCode == "0") {
                    this.btnList = data.data;
                }
                this.$emit('update:loading', false);
            },
            search() {
                this.$emit('search')
            },
            doBtn(type) {
                this.$emit('doBtn', type)
            },
        }
    }
</script>

<style scoped lang="scss">
    .toolBar {
        .el-main {
            padding: 0px;

        }

        .Xdriver {
            position: relative;
            bottom: 0px;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        ::v-deep .el-form-item__label {
            line-height: 40px;
        }

        ::v-deep .el-form-item__content {
            line-height: 40px;
        }

        ::v-deep .el-input__inner {
            height: 35px;
            line-height: 35px;
        }

        ::v-deep .el-form-item {
            margin-bottom: 0px;
        }
    }
</style>
